import { AppName } from '@components/AppName';
import { Logo } from '@components/Logo';
import { useBreakpoint } from '@hooks/useBreakpoint';
import { useSafeAreaPadding } from '@hooks/useSafeAreaPadding';
import { XStack, YStack } from 'tamagui';
import { LoginActionButton } from './components/LoginActionButton';
import { LoginAnimalImages } from './components/LoginAnimalImages';
import { LoginDecorativeBackground } from './components/LoginDecorativeBackground';
import { LoginFormCard } from './components/LoginFormCard';

export default function LoginScreen(): React.ReactNode {
  const { isSmallScreen } = useBreakpoint();
  const { bottomPadding } = useSafeAreaPadding();

  const renderSmallScreenLayout = (): React.ReactNode => (
    <YStack flex={1}>
      <LoginDecorativeBackground isSmallScreen={isSmallScreen}>
        <YStack gap="$3" alignItems="center">
          <Logo height={75} />
          <AppName />
        </YStack>
      </LoginDecorativeBackground>
      <YStack
        padding="$4"
        backgroundColor="$tertiary"
        paddingBottom={bottomPadding}
      >
        <LoginActionButton />
      </YStack>
    </YStack>
  );

  const renderLargeScreenLayout = (): React.ReactNode => (
    <XStack flex={1}>
      <LoginDecorativeBackground isSmallScreen={false}>
        <XStack alignItems="center" gap="$true">
          <Logo height={60} />
          <YStack
            height={60}
            width="$separator"
            backgroundColor="$borderColor"
          />
          <AppName />
        </XStack>
        <LoginAnimalImages />
      </LoginDecorativeBackground>
      <YStack
        justifyContent="center"
        alignItems="center"
        backgroundColor="$tertiary"
        width="40%"
      >
        <LoginFormCard />
      </YStack>
    </XStack>
  );

  return isSmallScreen ? renderSmallScreenLayout() : renderLargeScreenLayout();
}
